import React from 'react';

import useDropdownMenu from 'react-accessible-dropdown-menu-hook';

import * as S from './styles';

function Dropdown({ component: Component, options, ...rest }) {
    const { buttonProps, itemProps, isOpen } = useDropdownMenu(options.length);

    return (
        <S.ContainerDropdown {...buttonProps}>
            <Component />
            <S.Dropdown className={isOpen ? 'visible' : ''} {...rest} role="menu">
                {options.map(({ label, ...restOption }, index) => (
                    <S.Option {...itemProps[index]} {...restOption}>
                        {label}
                    </S.Option>
                ))}
            </S.Dropdown>
        </S.ContainerDropdown>
    );
}

export default Dropdown;
